import React from "react";
import { Helmet } from "react-helmet";

function Unauthorized() {
  return (
    <>
      <Helmet>
        <title>XPAY.World - Unauthorized</title>
      </Helmet>
      YOU DO NOT HAVE ACCESS TO THIS PAGE
    </>
  );
}

export default Unauthorized;
